import { useQuery } from "@tanstack/react-query";
import { getAgent } from "./agentsApi";

export const useAgentWithId = (agentId: string | undefined) => {
  const { data, isLoading } = useQuery({
    queryKey: ["agents", agentId],
    queryFn: ({ signal }) => getAgent(agentId!, signal),
    enabled: !!agentId,
  });

  return { data, isLoading };
};
